// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Header from '@/components/partials/Header-new';
import Footer from '@/components/partials/Footer';
import EventMonitorComponent from "@/components/EventMonitor.vue";
import VueGps from '@/plugins/VueGps.js';
import store from '@/store/store.js';
import EventUtil from '@/utils/event.util.js';
import AuthUtil from '@/utils/auth.util.js';
import VueResource from 'vue-resource';
// import axios from 'axios';
import _ from 'lodash/lodash';
import { AuthService } from "@/services/auth.service.js";
import { JsonDenormalizer } from '@/helpers/JsonDenormalizer.js'
import { ToastProgrammatic as Toast } from 'buefy';
import "@/filters/filters.js";
import "@/mixins/globalMixin.js";

Vue.config.productionTip = false

Vue.use(VueResource);
Vue.use(VueGps);
Vue.component('app-header', Header);
Vue.component('app-footer', Footer);
Vue.component('event-monitor', EventMonitorComponent);

/**
 * Imports from router/index.js
 */
import Buefy from "buefy";
Vue.use(Buefy, { defaultIconPack: "fa" });

import Datetime from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
Vue.use(Datetime);

// Vue i18n plugin
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'stormport', // set locale
  messages: {}, // set locale messages
})

import "@/plugins/auth0";

// ------------------------------------------------------------------
// START: Interceptors for AJAX requests and responses
// ------------------------------------------------------------------

// Ideally, we'd like to use axios moving forwards as vue-resource
// has some short-comings around things like async interceptors.


// REMINDER: It doesn't seem possible to use promises inside VueResource
// interceptors as: https://github.com/pagekit/vue-resource/issues/675
Vue.http.interceptors.push(function (request, next) {


	// if (request.url.includes('master_token')) {

	// 	const master_token = AuthUtil.getMaterAuthToken();

	// 	if (master_token) request.headers.set('Authorization', `Bearer ${master_token}`);

	// }

	if (request.url.toLowerCase().indexOf(process.env.API_URL.toLowerCase()) == 0) {

		// const token = store.state.Auth.token;
		const token = AuthUtil.getAuthToken();

		if (token) request.headers.set('Authorization', `Bearer ${token}`);
	}

	return function (response) {

		if (!response || !response.hasOwnProperty('status')) return;

		// We can handle HTTP and/or validation errors at a global level
		if ([200, 201, 204, 301, 302].indexOf(response.status) < 0) {

            EventUtil.$emit('responseError', response.data);

			// If we receive a 40x while on on non-public pages then redirect to login
			if ([401, 403].indexOf(response.status) >= 0) {
				if (!_.get(router, 'currentRoute.meta.public')) {
					const message = "Redirecting to login. Invalid or expired session.";
					window.console && console.log(message);
					Toast.open({
						message,
						type: 'is-danger'
					});
					localStorage.clear();
					store.dispatch('Auth/clearToken');
					// router.push({ name: 'login' });
					return;
				}
			}

			// Since upgrading from Lumen to Laravel, there is a small inconsistency
			// with how validation error messages are returned from the API server
			// (so we are simply going to accommodate multiple formats for now)
			const validationErrors = _.get(response, 'data.errors', {});  // Laravel 422
			let messages = _.get(response, 'data.message', {});  // Legacy format
			messages = _.isString(messages) ? { message: [messages] } : messages;
			messages = Object.assign({}, messages, validationErrors);

			let items = [];

			_.forEach(messages, (payload, ki) => {
				if (Array.isArray(payload)) {
					const not_empty = payload.filter(Boolean);
					if (not_empty.length) items = items.concat(not_empty);
				}
			});

			// If we got this far without encountering an error message
			// then we'll use a generic one (since bad status code)
			if (!items.length) items.push(`An unexpected error occurred (${response.status}).`);

			if (items.length > 0) EventUtil.$emit('validationErrors', items);

			// Could set the ok flag to false for easier error handling. Not sure about this yet.
			// (axios has custom option to reject promise when status < 200 or > 299 etc.)
			// response.ok = false;
		}
	}
});

// ------------------------------------------------------------------
// END: Interceptors for AJAX requests and responses
// ------------------------------------------------------------------

// ------------------------------------------------------------------
// START: Check auth token validity on each route change
// ------------------------------------------------------------------

router.beforeEach(async (to, from, next) => {

	// window.console && console.log(`Navigating to ${to.path}`);
	// console.log(to);
	// console.log(from);
	// console.log(next);
	// console.log(store.state.Auth.token);

	if (_.get(to, 'meta.public') !== true) {
		if (!store.state.Auth.token) {
			// This will redirect user to auth0 login page
			store.dispatch('Auth/clearToken');
			// next({ name: 'login' });
		} else {
			store.dispatch('routeLoading');

			if (to.name == 'login') {
				next({ name: 'profile' });
			}
			try {
				const response = await AuthService.getUser();
				const user = JsonDenormalizer.denormalize(response.data);

				if (!user.active) {
					localStorage.clear();
					store.dispatch('routeLoading', false);
					Toast.open({
						message: "User account is not currently active.",
						type: 'is-danger'
					});
					window.console && console.log("Redirecting to login (inactive user account)");
					store.dispatch("Auth/clearToken");
					// next({ name: 'login' });
				}

				// if (store.state.Auth.master_token != store.state.Auth.token) {

				// 	const master_user_response = await AuthService.getMasterUser();

				// 	const master_user = JsonDenormalizer.denormalize(master_user_response.data);

				// 	store.dispatch('Auth/setMasterUser', master_user);

				// }

				store.dispatch('Auth/setUser', user);


				const roleChecked = to.matched.every(record => {
					const roles = record.meta.roles || [];
					return roles.every(role => store.getters['Auth/hasRole'](role));
				});

				const permissionChecked = to.matched.every(record => {
					const permissions = record.meta.permissions || [];
					return permissions.every(permission =>
						store.getters['Auth/hasPermission'](permission)
					);
				});

				const reverseRole = to.matched.every(record => {

					const roles = record.meta.reverseRoles || [];

					return roles.every(role => !store.getters['Auth/hasRole'](role));

				});


				if (roleChecked && permissionChecked && reverseRole) {
					next();
				} else {
					next('/');
					// This will trigger an infinite loop
					// next({ name: store.getters['Auth/startRoute'] });
				}
			} catch (err) {

				EventUtil.$emit('error', "Please login to access the requested page.");
				// clear local storage
				localStorage.clear();
				store.dispatch('Auth/clearToken');

				// next({ name: 'login' });
			}

			store.dispatch('routeLoading', false);
		}
	}
	else {
		// [2020-05-04]
		// For now we'll just redirect to the next page since it's public.
		// The login route (public) in particular has custom logic for
		// checking current auth token or auto-sign-in token in URL.
		// @todo - move login route auth token checks to here to
		// prevent login page UI from rendering with a spinner.
		next();
	}
});

router.afterEach(_.throttle((to, from) => {

	const haystack = document.documentElement.innerHTML;
	const needle = /static\/js\/app\.[a-f\d]{20}\.js/g;
	const current_hashes = haystack.match(needle);
	const current_hash = current_hashes ? current_hashes[0] : false;

	if (current_hash) {

		const ts = (new Date()).getTime(); // for cache-busting.

		Vue.http.get('/index.html', { params: { ts } }).then(res => {

			const new_hashes = res.body.match(needle);
			const new_hash = new_hashes ? new_hashes[0] : false;

			if (current_hash != new_hash) {

				// New version of JS detected on the server...
				window.location.reload(true);
			}
		});
	}

}, 3600000));  // one check per hour

// ------------------------------------------------------------------
// END: Check auth token validity on each route change
// ------------------------------------------------------------------

/* eslint-disable no-new */
new Vue({
	el: '#app',
	i18n,
	store,
	router,
	components: { App },
	template: '<App/>'
});


// WEBPACK FOOTER //
// ./src/main.js